/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const UserAdminIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'User Admin',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M13.62 25.92a12.287 12.287 0 0 1 5.427-10.2 1.48 1.48 0 0 1 .331-.753 10.775 10.775 0 0 0 1.962-3.679 9.906 9.906 0 0 0 .577-3.146 10.792 10.792 0 0 0-.517-3.428A6.358 6.358 0 0 0 14.961 0a6.8 6.8 0 0 0-4.05 1.229 6.032 6.032 0 0 0-1.3 1.33A9.021 9.021 0 0 0 7.963 8.1a9.453 9.453 0 0 0 .276 2.133 10.975 10.975 0 0 0 2.261 4.774 1.443 1.443 0 0 1 .367.93c.031.837.083 1.466.083 2.032a1.431 1.431 0 0 1-1.25 1.444c-8.366.728-9.673 6.45-9.673 8.707 0 .251.048 1.526.048 1.526H14.2a12.284 12.284 0 0 1-.58-3.726Z"
    />
    <path
      d="M35.23 24.541h-2.415a6.98 6.98 0 0 0-1.02-2.476l1.72-1.72a.69.69 0 0 0 0-.975l-1.045-1.045a.69.69 0 0 0-.975 0l-1.72 1.72a6.983 6.983 0 0 0-2.475-1.02V16.61a.69.69 0 0 0-.69-.69h-1.38a.69.69 0 0 0-.69.69v2.415a6.983 6.983 0 0 0-2.475 1.02l-1.72-1.72a.69.69 0 0 0-.975 0l-1.045 1.045a.69.69 0 0 0 0 .975l1.72 1.72a6.98 6.98 0 0 0-1.02 2.476H16.61a.69.69 0 0 0-.69.69v1.379a.69.69 0 0 0 .69.69h2.415a6.98 6.98 0 0 0 1.02 2.476l-1.72 1.72a.689.689 0 0 0 0 .975l1.045 1.045a.69.69 0 0 0 .975 0l1.72-1.72a6.983 6.983 0 0 0 2.475 1.02v2.414a.69.69 0 0 0 .69.69h1.38a.69.69 0 0 0 .69-.69v-2.415a6.983 6.983 0 0 0 2.475-1.02l1.72 1.72a.69.69 0 0 0 .975 0l1.045-1.045a.689.689 0 0 0 0-.975l-1.72-1.72a6.98 6.98 0 0 0 1.02-2.476h2.415a.69.69 0 0 0 .69-.69V25.23a.69.69 0 0 0-.69-.689Zm-9.31 4.975a3.6 3.6 0 1 1 3.6-3.6 3.6 3.6 0 0 1-3.6 3.599Z"
    />
  </svg>`;
};
